import { combineReducers } from 'redux';
import quote from './quote';

export default combineReducers({
  quote,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js